export const INSTALLATION_NUMBER_LENGTH = 15

export const INSTALLATION_NUMBER_ERROR_MESSAGE = `Deve conter exatamente ${INSTALLATION_NUMBER_LENGTH} dígitos`

export const INSTALLATION_NUMBER_REGEX = new RegExp(`^\\d{${INSTALLATION_NUMBER_LENGTH}}$`)

/**
 * Máscara do campo Instalação / UC: aceita apenas dígitos, sem formatação,
 * limitada a INSTALLATION_NUMBER_LENGTH caracteres.
 */
export const INSTALLATION_NUMBER_MASK = '#'.repeat(INSTALLATION_NUMBER_LENGTH)
